import { group } from 'radash'

import { Offer } from '@wwt/entities/search-response'
import { showOfferConfigurationOfferStatuses } from '@wwt/shared/config'
import { extractFeaturesFromOffer } from '@wwt/shared/utils'

import { LOCATION_TAB_NAME } from '../config'

export const useLocationSection = (offer: Offer | null) => {
	const allFeatures = extractFeaturesFromOffer(
		offer,
		undefined,
		undefined,
		feature => feature.group?.tabName === LOCATION_TAB_NAME
	)

	const locationFeatures =
		group(allFeatures, feature => feature.group?.name ?? 'null').Location ?? []

	const isOfferConfigurationStatuses =
		offer?.IDs.status &&
		showOfferConfigurationOfferStatuses.includes(offer?.IDs.status)

	return {
		locationFeatures,
		longitude: offer?.hotelStatic.geolocation.longitude ?? 0,
		latitude: offer?.hotelStatic.geolocation.latitude ?? 0,
		isOfferConfigurationDisabled: !isOfferConfigurationStatuses
	}
}
